import { useApi } from '../../hooks/useApi';
import { useEffect, useRef, useState } from 'react';
import Modal from '../../components/Modal';
import logger from "../../utils/logger";
import { saveSeoTransfers } from '../../components/OzonSeoUniqualization';
import { fmtDateTime } from '../../utils/ruDates';
import { METRIC_LABELS } from './TaskResultLinksSection';
const AI_AGENT_NAMES = {
  analyst: 'Аналитик',
  product: 'Товарный',
  reference: 'Справочный',
  seo: 'SEO',
  ads: 'Рекламный',
  pricing: 'Цены',
  reviews: 'Отзывы',
  visual: 'Визуал',
  fbs: 'FBS',
  dbs: 'DBS',
  fbo: 'FBO',
  pickup: 'Вывоз',
  certificates: 'Сертификаты',
  launch: 'Запуск',
  support: 'Поддержка'
};
function formatFileSize(fileSizeBytes) {
  if (!Number.isFinite(fileSizeBytes)) return '';
  if (fileSizeBytes >= 1024 * 1024) {
    return `${(fileSizeBytes / (1024 * 1024)).toFixed(2)} МБ`;
  }
  if (fileSizeBytes >= 1024) {
    return `${(fileSizeBytes / 1024).toFixed(1)} КБ`;
  }
  return `${fileSizeBytes} Б`;
}
function parseSeoResultBlock(body) {
  const text = String(body || '');
  const match = text.match(/\[SEO_RESULT\]([\s\S]*?)\[\/SEO_RESULT\]/i);
  if (!match) return null;
  const result = {};
  for (const rawLine of match[1].split(/\r?\n/)) {
    const line = rawLine.trim();
    if (!line) continue;
    const separator = line.indexOf(':');
    if (separator <= 0) continue;
    const key = line.slice(0, separator).trim().toLowerCase();
    const value = line.slice(separator + 1).trim();
    if (key === 'offer_id') result.offerId = value;
    if (key === 'sku') result.sku = value;
    if (key === '\u043d\u0430\u0437\u0432\u0430\u043d\u0438\u0435' || key === 'title') result.name = value;
    if (key === '\u0430\u043d\u043d\u043e\u0442\u0430\u0446\u0438\u044f' || key === 'description') result.description = value;
    if (key === 'название' || key === 'title') result.name = value;
    if (key === 'аннотация' || key === 'description') result.description = value;
  }
  return result.name || result.description ? result : null;
}

function isAffirmativeSeoTransferReply(value) {
  const text = String(value || '').trim().toLowerCase();
  if (!text) return false;
  const exactMarkers = [
    '\u0434\u0430',
    '\u0434\u0430\u043b',
    '\u043e\u043a',
    '\u043e\u043a\u0435\u0439',
    '\u043c\u043e\u0436\u043d\u043e',
    '\u0441\u043e\u0433\u043b\u0430\u0441\u0435\u043d',
    '\u0441\u043e\u0433\u043b\u0430\u0441\u043d\u0430',
    '\u0441\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u0430\u043d\u043e',
    '\u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044e',
    '\u043f\u0440\u0438\u043d\u044f\u0442\u044c',
    '\u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e',
  ];
  if (exactMarkers.includes(text)) return true;
  const phraseMarkers = [
    '\u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c',
    '\u043f\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0439',
    '\u043f\u0435\u0440\u0435\u043d\u0435\u0441\u0442\u0438',
    '\u043f\u0435\u0440\u0435\u043d\u043e\u0441\u0438',
    '\u043f\u0440\u0438\u043d\u044f\u0442\u044c',
    '\u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e',
  ];
  if (phraseMarkers.some(marker => text.includes(marker))) return true;
  return false;
}

function TaskDetailModal({
  open,
  onClose,
  taskDetailPanelRef,
  taskDetailSize,
  taskDetailBusy,
  taskDetail,
  user,
  openTaskEdit,
  taskDescriptionExpanded,
  setTaskDescriptionExpanded,
  companyUsers,
  getUserLabel,
  taskStatusLabels,
  marketplaces,
  getWorkspaceById,
  taskHistory,
  taskHistoryExpanded,
  setTaskHistoryExpanded,
  formatHistoryEntry,
  formatDateTime,
  taskComments,
  taskCommentBody,
  taskCommentFiles,
  setTaskCommentBody,
  setTaskCommentFiles,
  handleAddTaskComment,
  handleStatusChange,
  handleExecuteAiTask,
  handleDeleteTask,
  startTaskResize,
  request,
  API_BASE_URL,
  showStatus
}) {
  const { fetchBlob } = useApi();
  const fileInputRef = useRef(null);
  const [taskResultBinding, setTaskResultBinding] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!open || !taskDetail?.id || !request) {
      setTaskResultBinding(null);
      return () => {
        cancelled = true;
      };
    }
    request(`/api/v1/tasks/${taskDetail.id}/result-binding`, {})
      .then((binding) => {
        if (!cancelled) setTaskResultBinding(binding || null);
      })
      .catch((error) => {
        logger.error(error);
        if (!cancelled) setTaskResultBinding(null);
      });
    return () => {
      cancelled = true;
    };
  }, [open, request, taskDetail?.id]);
  if (!open) return null;
  const openFilePicker = () => {
    if (taskDetailBusy) return;
    fileInputRef.current?.click();
  };
  const onSelectFiles = event => {
    const selected = Array.from(event.target.files || []);
    if (!selected.length) return;
    setTaskCommentFiles(prev => {
      const keys = new Set(prev.map(file => `${file.name}:${file.size}:${file.lastModified}`));
      const append = selected.filter(file => {
        const key = `${file.name}:${file.size}:${file.lastModified}`;
        if (keys.has(key)) return false;
        keys.add(key);
        return true;
      });
      return [...prev, ...append];
    });
    event.target.value = '';
  };
  const removeSelectedFile = indexToRemove => {
    setTaskCommentFiles(prev => prev.filter((_, index) => index !== indexToRemove));
  };
  const transferSeoResultToSeoDrafts = async () => {
    if (taskDetail?.ai_agent_slug !== 'seo') return true;
    const latestSeoResult = [...(taskComments || [])]
      .reverse()
      .map(comment => parseSeoResultBlock(comment.body))
      .find(Boolean);
    if (!latestSeoResult) {
      showStatus?.('error', 'В комментариях нет блока [SEO_RESULT]. Нельзя принять SEO AI-задачу и перенести результат в SEO.');
      return false;
    }
    let binding = taskResultBinding;
    try {
      binding = binding || (request && taskDetail?.id ? await request(`/api/v1/tasks/${taskDetail.id}/result-binding`, {}) : null);
    } catch (error) {
      logger.error(error);
    }
    const accountId =
      binding?.marketplace_account_id ||
      taskDetail?.cabinets?.[0]?.marketplace_account_id ||
      taskDetail?.cabinet_ids?.[0];
    const offerId = latestSeoResult.offerId || latestSeoResult.sku || binding?.skus?.[0] || taskDetail?.result_skus?.[0];
    if (!accountId || !offerId) {
      showStatus?.('error', 'Не хватает кабинета или offer_id/SKU для переноса SEO-результата.');
      return false;
    }
    // Очередь переноса хранится на сервере: новый товар дописывается, остальные не трогаются.
    const saved = await saveSeoTransfers(request, accountId, {
      [offerId]: {
        originalDesc: '',
        seoText: latestSeoResult.description || '',
        productName: latestSeoResult.name || offerId,
        name: latestSeoResult.name || '',
      },
    });
    if (!saved) {
      showStatus?.('error', 'Не удалось перенести результат в SEO. Попробуйте ещё раз.');
      return false;
    }
    showStatus?.('success', 'SEO-результат перенесён в раздел SEO. Откройте SEO и проверьте ячейки перед отправкой.');
    return true;
  };
  const handleTaskCommentSubmit = async (event) => {
    const shouldApplySeo =
      taskDetail?.ai_agent_slug === 'seo' &&
      taskDetail?.status === 'review' &&
      isAffirmativeSeoTransferReply(taskCommentBody);
    const commentSent = await handleAddTaskComment(event);
    if (shouldApplySeo && commentSent && await transferSeoResultToSeoDrafts()) {
      await handleStatusChange(taskDetail.id, 'done');
    }
  };
  const downloadAttachment = async attachment => {
    try {
      const blob = await fetchBlob(attachment.download_url);
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = attachment.file_name || 'file';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      logger.error(error);
      showStatus?.('error', 'Не удалось скачать файл.');
    }
  };
  return <Modal open onClose={onClose} title="Задача" wide resizable panelRef={taskDetailPanelRef} panelStyle={taskDetailSize ? {
    width: `${taskDetailSize.width}px`,
    height: `${taskDetailSize.height}px`
  } : undefined}>

            {taskDetailBusy ? <div className="loading">
                    <span className="spinner" aria-hidden="true" />
                    <span>Загрузка...</span>
                </div> : taskDetail ? <div className="task-detail__layout">
                    <div className="task-detail__left">
                        <div className="task-detail__panel task-detail__panel--summary">
                            <div className="task-detail__panel-head">
                                <div>
                                    <div className="task-detail__panel-title">Заголовок задачи</div>
                                    <div className="task-detail__panel-value">
                                        {taskDetail.title || 'Без названия'}
                                    </div>
                                </div>
                                <div className="task-detail__panel-actions">
                                    {(() => {
                const isOwner = taskDetail.created_by_id === user?.id;
                const isSuper = user?.role === 'admin' || user?.is_owner;
                if (!isOwner && !isSuper) return null;
                return <button type="button" className="ghost" onClick={openTaskEdit}>

                                                Изменить
                                            </button>;
              })()}
                                </div>
                            </div>
                            <div className={`task-detail__description ${taskDescriptionExpanded ? 'is-expanded' : ''}`}>

                                {taskDetail.description || 'Описание отсутствует.'}
                                {!taskDescriptionExpanded && <div className="task-detail__fade" aria-hidden="true" />}
                            </div>
                            <button type="button" className="task-detail__expand" onClick={() => setTaskDescriptionExpanded(prev => !prev)}>

                                {taskDescriptionExpanded ? 'Свернуть' : 'Развернуть'}
                            </button>
                        </div>

                        <div className="task-detail__panel">
                            <div className="task-detail__panel-title">Детали</div>
                            {(() => {
            const participants = taskDetail.participants || [];
            const creator = participants.find(item => item.role === 'creator');
            const assignee = participants.find(item => item.role === 'assignee');
            const coAssignees = participants.filter(item => item.role === 'co_assignee');
            const watchers = participants.filter(item => item.role === 'watcher');
            const creatorUser = creator?.user || companyUsers.find(item => item.id === taskDetail.created_by_id);
            const assigneeUser = assignee?.user || companyUsers.find(item => item.id === taskDetail.assignee_id);
            return <div className="task-detail__rows">
                                        <div className="task-detail__row">
                                            <span>Постановщик</span>
                                            <span>{creatorUser ? getUserLabel(creatorUser) : '—'}</span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Главный исполнитель</span>
                                            <span>
                                                {taskDetail.assignee_type === 'ai_agent' && taskDetail.ai_agent_slug ? `🤖 ${AI_AGENT_NAMES[taskDetail.ai_agent_slug] || taskDetail.ai_agent_slug}` : assigneeUser ? getUserLabel(assigneeUser) : '—'}
                                            </span>
                                        </div>
                                        {taskDetail.queue_status && <div className="task-detail__row">
                                                <span>Очередь</span>
                                                <span style={{
                  color: taskDetail.queue_status === 'done' ? '#22c55e' : taskDetail.queue_status === 'failed' ? '#ef4444' : taskDetail.queue_status === 'processing' ? '#f59e0b' : '#6b7280'
                }}>
                                                    {taskDetail.queue_status === 'queued' && '⏳ В очереди'}
                                                    {taskDetail.queue_status === 'processing' && '🔄 Выполняется'}
                                                    {taskDetail.queue_status === 'done' && '✅ Ответ AI готов'}
                                                    {taskDetail.queue_status === 'failed' && '❌ Ошибка'}
                                                </span>
                                            </div>}
                                        <div className="task-detail__row">
                                            <span>Соисполнители</span>
                                            <span>
                                                {coAssignees.length ? coAssignees.map(item => getUserLabel(item.user)).join(', ') : '—'}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Наблюдатели</span>
                                            <span>
                                                {watchers.length ? watchers.map(item => getUserLabel(item.user)).join(', ') : '—'}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Дата выполнения</span>
                                            <span>
                                                {taskDetail.due_at ? fmtDateTime(taskDetail.due_at) : '—'}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Статус</span>
                                            <span className="task-detail__status">
                                                <span className={`chip chip--status-${taskDetail.status}`}>
                                                    {taskStatusLabels[taskDetail.status] || taskDetail.status}
                                                </span>
                                                {taskDetail.overdue && <span className="chip chip--danger">Просрочено</span>}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Дата создания</span>
                                            <span>
                                                {taskDetail.created_at ? fmtDateTime(taskDetail.created_at) : '—'}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Проект</span>
                                            <span>
                                                {taskDetail.workspace_name || getWorkspaceById(taskDetail.workspace_id)?.name || 'Без проекта'}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>Кабинеты</span>
                                            <span>
                                                {(taskDetail.cabinets || []).length === 0 ? '—' : taskDetail.cabinets.map(cabinet => {
                    const account = marketplaces.find(item => item.id === cabinet.marketplace_account_id);
                    return account?.account_name || cabinet.marketplace_account_id;
                  }).join(', ')}
                                            </span>
                                        </div>
                                        <div className="task-detail__row">
                                            <span>{'\u041f\u0440\u0438\u0432\u044f\u0437\u043a\u0430 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0430'}</span>
                                            <span>
                                                {taskResultBinding?.marketplace_account_id ? `${taskResultBinding.scope === 'skus' ? 'SKU' : '\u0412\u0435\u0441\u044c \u0430\u0441\u0441\u043e\u0440\u0442\u0438\u043c\u0435\u043d\u0442'}: ${(taskResultBinding.skus || []).join(', ') || '\u2014'}; ${(taskResultBinding.metrics || []).map(key => METRIC_LABELS[key] || key).join(', ') || '\u0431\u0435\u0437 \u043c\u0435\u0442\u0440\u0438\u043a'}` : (taskDetail.has_result_binding ? '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430...' : '\u041d\u0435\u0442')}
                                            </span>
                                        </div>
                                    </div>;
          })()}
                        </div>

                        <div className="task-detail__panel">
                            <div className="task-detail__panel-title">Теги</div>
                            <div className="task-detail__chips">
                                {(taskDetail.tags || []).length === 0 ? 'Нет тегов.' : taskDetail.tags.map(tag => <span key={tag} className="chip">
                                            {tag}
                                        </span>)}
                            </div>
                            {(() => {
            const participants = taskDetail.participants || [];
            const current = participants.find(item => item.user?.id === user?.id);
            const role = current?.role;
            const isSuper = user?.role === 'admin' || user?.is_owner;
            const isAssignee = taskDetail.assignee_id === user?.id;
            const canDelete = taskDetail.created_by_id === user?.id || isSuper;
            const canExecuteAi = taskDetail.assignee_type === 'ai_agent' && taskDetail.ai_agent_slug && taskDetail.status !== 'done';
            const aiBusy = taskDetail.queue_status === 'queued' || taskDetail.queue_status === 'processing';
            const actions = [];
            if (taskDetail.status === 'created' && (role === 'assignee' || isSuper || isAssignee)) {
              actions.push({
                label: 'Начать',
                variant: 'primary',
                status: 'in_progress'
              });
            }
            if (taskDetail.status === 'in_progress' && (role === 'assignee' || isSuper || isAssignee)) {
              actions.push({
                label: 'Завершить',
                variant: 'primary',
                status: 'review'
              });
            }
            if (taskDetail.status === 'review' && (role === 'creator' || isSuper)) {
              actions.push({
                label: 'Принять',
                variant: 'primary',
                status: 'done'
              });
              actions.push({
                label: 'На доработку',
                status: 'rejected'
              });
            }
            if (taskDetail.status === 'rejected' && (role === 'assignee' || isSuper || isAssignee)) {
              actions.push({
                label: 'Взять в работу',
                variant: 'primary',
                status: 'in_progress'
              });
            }
            if (!actions.length && !canDelete && !canExecuteAi) {
              return null;
            }
            return <>
                                        <div className="task-detail__panel-title">Действия</div>
                                        <div className="task-detail__action-buttons">
                                            {canExecuteAi && <button type="button" className="primary" onClick={() => handleExecuteAiTask(taskDetail.id)} disabled={taskDetailBusy || aiBusy}>

                                                    {aiBusy ? 'Выполняется...' : 'Выполнить'}
                                                </button>}
                                            {actions.map(action => <button key={action.status} type="button" className={action.variant === 'primary' ? 'primary' : 'ghost'} onClick={async () => {
                                                if (action.status === 'done' && !(await transferSeoResultToSeoDrafts())) return;
                                                handleStatusChange(taskDetail.id, action.status);
                                            }}>

                                                    {action.label}
                                                </button>)}
                                            {canDelete && <button type="button" className="danger" onClick={handleDeleteTask}>

                                                    Удалить задачу
                                                </button>}
                                        </div>
                                    </>;
          })()}
                        </div>
                    </div>

                    <div className="task-detail__right">
                        <div className="task-detail__panel task-detail__panel--chat">
                            <div className="task-detail__panel-title">Комментарии</div>
                            <div className="task-detail__chat-log">
                                {(() => {
              const orderedComments = [...taskComments].sort((a, b) => new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime());
              return orderedComments.length === 0 ? <div className="empty">Комментариев пока нет.</div> : orderedComments.map(comment => {
              const isMine = comment.user?.id === user?.id;
              return <div key={comment.id} className={`task-detail__chat-message ${isMine ? 'is-mine' : ''}`}>

                                                <div className="task-detail__chat-meta">
                                                    <strong>{getUserLabel(comment.user)}</strong>
                                                    <span className="muted">
                                                        {comment.created_at ? fmtDateTime(comment.created_at) : ''}
                                                    </span>
                                                </div>
                                                <div className="task-detail__chat-bubble">{comment.body}</div>
                                                {(comment.attachments || []).length > 0 && <div className="task-comment__attachments">
                                                        {(comment.attachments || []).map(attachment => <button key={attachment.id} type="button" className="task-comment__attachment" onClick={() => downloadAttachment(attachment)}>

                                                                <span>{attachment.file_name}</span>
                                                                <span className="muted">
                                                                    {formatFileSize(attachment.file_size_bytes)}
                                                                </span>
                                                            </button>)}
                                                    </div>}
                                            </div>;
            });
            })()}
                            </div>
                            <form className="task-detail__chat-form" onSubmit={handleTaskCommentSubmit}>
                                <textarea rows={3} placeholder="Напишите комментарий..." value={taskCommentBody} onChange={event => setTaskCommentBody(event.target.value)} />

                                <input ref={fileInputRef} type="file" multiple onChange={onSelectFiles} className="task-comment__file-input" />

                                {taskCommentFiles.length > 0 && <div className="task-comment__selected-files">
                                        {taskCommentFiles.map((file, index) => <div key={`${file.name}:${file.size}:${file.lastModified}`} className="task-comment__selected-file">
                                                <span>{file.name}</span>
                                                <span className="muted">{formatFileSize(file.size)}</span>
                                                <button type="button" className="ghost" onClick={() => removeSelectedFile(index)}>

                                                    Убрать
                                                </button>
                                            </div>)}
                                    </div>}
                                <div className="task-comment__controls">
                                    <button type="button" className="ghost" onClick={openFilePicker} disabled={taskDetailBusy}>
                                        Добавить файлы
                                    </button>
                                    <span className="muted">Максимум 5 МБ на 1 файл</span>
                                    <button type="submit" disabled={taskDetailBusy || !taskCommentBody.trim() && taskCommentFiles.length === 0}>

                                        Отправить
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className="task-detail__panel">
                            <div className="task-detail__panel-title">Изменения</div>
                            <div className={`task-detail__history ${taskHistoryExpanded ? 'is-expanded' : ''}`}>

                                {taskHistory.length ? taskHistory.map(entry => {
              const author = entry.user ? getUserLabel(entry.user) : 'Система';
              const message = formatHistoryEntry(entry);
              const when = formatDateTime(entry.created_at);
              return `${when} — ${author}: ${message}`;
            }).join('\n') : 'Изменений пока нет.'}
                                {!taskHistoryExpanded && <div className="task-detail__fade" aria-hidden="true" />}
                            </div>
                            <button type="button" className="task-detail__expand" onClick={() => setTaskHistoryExpanded(prev => !prev)}>

                                {taskHistoryExpanded ? 'Свернуть' : 'Развернуть'}
                            </button>
                        </div>
                    </div>
                </div> : <div className="empty">Не удалось загрузить задачу.</div>}
            <div className="modal__resizer" role="presentation" onMouseDown={startTaskResize} />
        </Modal>;
}
export default TaskDetailModal;
